module.exports = __webpack_public_path__ + "img/panel_h.b942a455.png";